import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { eventBus } from '../../../utils';

import { setSearchComponent } from '../../../redux/board/reducer';
import { KEYS_CODE } from '../../../utils/keysCode';
import './style.scss';

const SearchForm = (props) => {
  const dispatch = useDispatch();
  const { placeholder = 'Search', onDataSearch = () => {}, isHome = false, id = 'moSearchForm' } = props;
  const [value, setValue] = useState(undefined);
  const searching = useSelector((appState) => appState.board.searching);

  const onSearch = (searchValue) => {
    eventBus.emit('on-search-project', searchValue);
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (isHome) {
        onSearch(value);
      } else {
        onDataSearch(value);
      }
    }
  };

  const onChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValue(e.target.value);
    if (!isHome) {
      setTimeout(() => {
        onDataSearch(e.target.value);
      }, 300);
    } else {
      setTimeout(() => {
        onSearch(e.target.value);
      }, 300);
    }
  };
  const onFocus = () => {
    eventBus.emit('on-search-component');
    dispatch(setSearchComponent(true));
  };
  const onBlur = () => {
    eventBus.emit('on-search-component');
    dispatch(setSearchComponent(false));
  };

  const keyCodeEvents = (e) => {
    console.log('------------Search form-------');
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey) {
      if (e.keyCode === KEYS_CODE.Z) {
        if (!searching) return;
        setValue('');
      }
    }
  };
  const onFocusSearch = () => {
    document.getElementById(id).focus();
  };
  useEffect(() => {
    document.addEventListener('keydown', keyCodeEvents);
    return () => {
      document.removeEventListener('keydown', keyCodeEvents);
    };
  }, []);
  useEffect(() => {
    eventBus.on('focus-search-element', onFocusSearch);
    return () => {
      eventBus.off('focus-search-element', onFocusSearch);
    };
  }, [id]);
  return (
    <div>
      <Input
        {...(isHome ? {} : { id })}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        value={value}
        {...(!isHome ? { prefix: <SearchOutlined style={{ color: '#888' }} /> } : {})}
        className={!isHome ? 'mo__search' : 'mo__search-home'}
        onChange={onChange}
        onKeyDown={(e) => onKeyDown(e)}
        {...(isHome ? { suffix: <SearchOutlined style={{ color: '#888', fontSize: '18px' }} /> } : {})}
      />
    </div>
  );
};

export default SearchForm;
